import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, FormGroup, Label, Table } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import FilterMember from "./filterMember";
import { history } from "../../../../app/AppRouter";
import Pagination from "../../../../components/pagination";
import { store } from "../../../../redux/storeConfig/store";
import { setMembersData } from "../../../../redux/actions/members/memberAction";

import {
  getMember,
  getMembers,
  getMembersForExport,
  // getMemberAttribute,
} from "../../../../redux/actions/api/apiAction";
import PhoneInput from "react-phone-number-input";
import moment from "moment";
import { debounce } from "lodash";

import {
  onHeaderCheckboxClickHandler,
  checkboxOnClickHandler,
  checkCheckedSelection,
  clearSelection,
} from "../../../../redux/actions/selectAction";
import Excel from "../../../../components/excel";
import { toastr } from "react-redux-toastr";
import { CapitalizeFirstLetter } from "../../../../helper/helpers";

const excelRef = React.createRef();
const excelRef1 = React.createRef();

class MembersList extends Component {
  constructor(props) {
    super(props);
    this.handleSearchThrottled = debounce(this.search, 0);
  }
  state = {
    data: [],
    page: 1,
    limit: 10,
    search: "",
    filter: "",
    sort: "",
    allExcelExportData: [],
    gender:""
  };

  handleClick = async (value) => {
    //console.log("getMember edit", value);
    await store.dispatch(getMember(value.id));
    history.push(`/gym-panel/membersinfo/edit/${value.id}`);
  };
  async componentDidMount() {
    store.dispatch(
      getMembers(
        1,
        10,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
    store.dispatch(clearSelection("members"));
  }

  componentWillUnmount = async () => {
    await store.dispatch(setMembersData([]));
  };

  async basicInfo(value) {
    // await store.dispatch(getMember(value));
    history.push(`/gym-panel/membersinfo/${value.id}`);
  }
  handleExcel = async () => {
    // const data = await fetchData(page, limit, search, filter);
    if (this.props.selection.length <= 0) {
      toastr.error("Select any member first");
      return;
    }
    await this.setState({ data: this.props.members });
    excelRef.current.handleDownload();
    store.dispatch(clearSelection("members"));
  };
  convertToCsv = async () => {
    let usersAll = this.props.members || [];
    let users = usersAll.filter((one) => {
      if (this.props.selection.includes(one.id)) {
        return one;
      }
    });
    let csv = [
      ["ID", "Name", "Email", "Phone", "Start Date", "End Date", "Membership"],
    ];
    users.forEach(
      ({ id, name, email, phone, startDate, endDate, packageName, price }) => {
        let csvArray = [
          `${id}`,
          `${name}`,
          `${email}`,
          `${phone}`,
          `${
            startDate ? moment(startDate).format("DD-MM-YYYY") : "Not Available"
          }`,
          `${endDate ? moment(endDate).format("DD-MM-YYYY") : "Not Available"}`,
          `${packageName} - ${price ? price : ""}`,
        ];
        csv.push(csvArray);
      }
    );
    return csv;
  };
  handlepdf = async (download = true) => {
    const { pdf } = await import("../../../../components/pdf");
    if (this.props.selection.length <= 0) {
      toastr.error("Select any member first");
      return;
    }
    let data = await this.convertToCsv();
    //console.log("data", data);
    data[0] = [
      { text: "ID", alignment: "center", color: "#ffffff", bold: true },
      { text: "Name", alignment: "center", color: "#ffffff", bold: true },
      { text: "Email", alignment: "center", color: "#ffffff", bold: true },
      { text: "Phone", alignment: "center", color: "#ffffff", bold: true },
      { text: "Start Date", alignment: "center", color: "#ffffff", bold: true },
      { text: "End Date", alignment: "center", color: "#ffffff", bold: true },
      { text: "Membership", alignment: "center", color: "#ffffff", bold: true },
    ];
    const docDefinition = {
      content: [
        {
          text: "Connect To Fit\n\n",
          style: "header",
        },
        {
          columns: [
            { width: "*", text: "" },
            {
              width: "auto",
              table: {
                // headers are automatically repeated if the table spans over multiple pages
                // you can declare how many rows should be treated as headers
                headerRows: 1,
                widths: [
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                ],
                body: data,
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0;
                },
                vLineWidth: function(i, node) {
                  return 0;
                },
                hLineColor: function(i, node) {
                  return "#ffffff";
                },
                vLineColor: function(i, node) {
                  return "#ffffff";
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  if (rowIndex === 0)
                    return rowIndex % 2 === 0 ? "#2d4154" : null;
                  return rowIndex % 2 === 0 ? "#ffffff" : "#f3f3f3";
                },
              },
            },
            { width: "*", text: "" },
          ],
        },
      ],
      styles: {
        header: {
          alignment: "center",
          fontSize: 18,
          bold: true,
        },
      },
      defaultStyle: {
        fontSize: 10,
      },
    };
    download
      ? pdf(docDefinition, true, "members")
      : pdf(docDefinition, false, "members");
    store.dispatch(clearSelection("members"));
  };

  // handleClick() {
  //   history.push("/gym-panel/membersinfo");
  // }
  // async basicInfo(value) {
  //   // await store.dispatch(setMemberData(value));
  //   // await store.dispatch(getPlans());
  //   history.push('/gym-panel/membersinfo');
  // }

  search = async (value, filter,sort,gender) => {
    console.log({value, filter, sort,gender},"triiiiiiiiiiiiiiiiiiiiiiii")
    // this.setState({
    //   limit: 10,
    //   page: 1,
    //   search: value,
    //   sort: sort,
    //   filter: filter,
    //   gender: gender
    // });
    // //console.log("search member", value);
    // store.dispatch(
    //   getMembers(
    //     1,
    //     10,
    //     JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
    //     value,
    //     sort,
    //     filter,
    //     gender
    //   )
    // );
    // store.dispatch(clearSelection("members"));
  };
  getData = (limit, page) => {
    this.setState({ page: page, limit: limit });
    //console.log("value of limit", limit, page);
    store.dispatch(
      getMembers(
        page,
        limit,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
        this.state.search,
        this.state.sort,
        this.state.filter,
        this.state.gender
      )
    );
    store.dispatch(clearSelection("members"));
  };

  handleExcelAll = async () => {
    let data = await store.dispatch(
      getMembersForExport(
        1,
        9999999,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );
    this.setState({ allExcelExportData: data });
    excelRef1.current.handleDownload();
  };

  convertToCsvAll = async () => {
    let users = await store.dispatch(
      getMembersForExport(
        1,
        9999999,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym
      )
    );

    let csv = [
      ["ID", "Name", "Email", "Phone", "Start Date", "End Date"],
    ];

    users.forEach(
      ({ id, name, email, phone, startDate, endDate, packageName, price }) => {
        let csvArray = [
          `${id}`,
          `${name}`,
          `${email}`,
          `${phone}`,
          `${
            startDate ? moment(startDate).format("DD-MM-YYYY") : "Not Available"
          }`,
          `${endDate ? moment(endDate).format("DD-MM-YYYY") : "Not Available"}`,
        ];
        csv.push(csvArray);
      }
    );

    return csv;
  };

  handlepdfAll = async (download = true) => {
    const { pdf } = await import("../../../../components/pdf");
    let data = await this.convertToCsvAll();
    data[0] = [
      { text: "ID", alignment: "center", color: "#ffffff", bold: true },
      { text: "Name", alignment: "center", color: "#ffffff", bold: true },
      { text: "Email", alignment: "center", color: "#ffffff", bold: true },
      { text: "Phone", alignment: "center", color: "#ffffff", bold: true },
      { text: "Start Date", alignment: "center", color: "#ffffff", bold: true },
      { text: "End Date", alignment: "center", color: "#ffffff", bold: true },
    ];
    
    const docDefinition = {
      content: [
        {
          text: "Connect To Fit\n\n",
          style: "header",
        },
        {
          columns: [
            { width: "*", text: "" },
            {
              width: "auto",
              table: {
                // headers are automatically repeated if the table spans over multiple pages
                // you can declare how many rows should be treated as headers
                headerRows: 1,
                widths: [
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                  "auto",
                ],
                body: data,
              },
              layout: {
                hLineWidth: function(i, node) {
                  return 0;
                },
                vLineWidth: function(i, node) {
                  return 0;
                },
                hLineColor: function(i, node) {
                  return "#ffffff";
                },
                vLineColor: function(i, node) {
                  return "#ffffff";
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  if (rowIndex === 0)
                    return rowIndex % 2 === 0 ? "#2d4154" : null;
                  return rowIndex % 2 === 0 ? "#ffffff" : "#f3f3f3";
                },
              },
            },
            { width: "*", text: "" },
          ],
        },
      ],
      styles: {
        header: {
          alignment: "center",
          fontSize: 18,
          bold: true,
        },
      },
      defaultStyle: {
        fontSize: 10,
      },
    };
    download
      ? pdf(docDefinition, true, "members")
      : pdf(docDefinition, false, "members");
  };
  render() {
    //console.log("value of members", this.props.members);
    const excelColumn = [
      {
        label: "Name",
        value: "name",
      },
      {
        label: "ID Num",
        value: "id",
      },
      {
        label: "Email",
        value: "email",
      },
      {
        label: "Phone",
        value: "phone",
      },

      {
        label: "Start Date",
        value: "starting",
      },
      {
        label: "End Date",
        value: "ending",
      },
    ];
    return (
      <div className="body-layout-main-block">
        <div className="members-list-block panel">
          {/* here successfully block when you used please uncomment this block */}
          {/* <SuccessFul title="Trainer was added successfully" /> */}
          <FilterMember
            searchLabel="What are you looking for?"
            searchPlaceholder="Search members by name"
            selectLabel="Add filters to search"
            type="members"
            handleExcel={this.handleExcel}
            handlepdf={this.handlepdf}
            search={this.handleSearchThrottled}
            handleExcelAll={this.handleExcelAll}
            handlepdfAll={this.handlepdfAll}
            selection={this.props.selection}
            data={this.props.members}
          />
          <Excel
            refs={excelRef}
            data={this.props.members.filter((one) => {
              if (this.props.selection.includes(one.id)) {
                let membership = `${one.packageName} - ${
                  one.price ? one.price : ""
                }`;
                one.starting = moment(one.startDate).format("DD-MM-YYYY");
                one.ending = moment(one.endDate).format("DD-MM-YYYY");
                one.membership = membership;
                return one;
              }
            })}
            columns={excelColumn}
            name="Connect to fit"
            filename="Connect to fit Member - List"
          />
          <Excel
            refs={excelRef1}
            data={this.state.allExcelExportData.filter((one) => {
              let membership = `${one.packageName} - ${
                one.price ? one.price : ""
              }`;
              one.starting = moment(one.startDate).format("DD-MM-YYYY");
              one.ending = moment(one.endDate).format("DD-MM-YYYY");
              one.membership = membership;
              return one;
            })}
            columns={excelColumn}
            name="Connect to fit"
            filename="Connect to fit Member - List"
          />
          <div className="table-section mt-3">
            <div className="table-main-block">
              <Table striped responsive hover className="mb-0">
                <thead>
                  <tr>
                    <th className="small">
                      <span className="selction-box">
                        <FormGroup className="checkboxes-list" check>
                          <Label check className="container-blk">
                            <Input
                              type="checkbox"
                              onChange={(e) => {
                                store.dispatch(
                                  onHeaderCheckboxClickHandler(
                                    this.props.members,
                                    "members"
                                  )
                                );
                              }}
                              checked={this.props.selectAll}
                            />{" "}
                            <span className="checkmark"></span>
                          </Label>
                        </FormGroup>
                      </span>
                    </th>
                    <th>Member</th>
                    <th>ID Num</th>
                    <th>Account Type</th>
                    <th>Mobile</th>
                    <th>Email</th>
                    {/*<th>Subscribed to</th>*/}
                    <th className="small"></th>
                  </tr>
                </thead>
                <tbody>
                  {/* {console.log(this.props.members)} */}
                  {this.props.members.map((value, index) => {
                    return (
                      <tr>
                        <td>
                          <span className="selction-box">
                            <FormGroup className="checkboxes-list" check>
                              <Label check className="container-blk">
                                <Input
                                  // type="checkbox"
                                  type="checkbox"
                                  onChange={(e) =>
                                    store.dispatch(
                                      checkboxOnClickHandler(
                                        value.id,
                                        this.props.members,
                                        "members"
                                      )
                                    )
                                  }
                                  checked={checkCheckedSelection(
                                    value.id,
                                    "members"
                                  )}
                                />{" "}
                                <span className="checkmark"></span>
                              </Label>
                            </FormGroup>
                          </span>
                        </td>
                        <td
                          className="c-pointer"
                          onClick={() => this.basicInfo(value)}
                        >
                          <div className="d-flex align-items-center">
                            <span
                              className={
                                value.subscriptionStatus === "ACTIVE"
                                  ? `block-1 member-status  active`
                                  : "block-1 member-status non-active"
                              }
                            >
                              <img
                                src={
                                  value.image
                                    ? value.image
                                    : require("../../../../assets/images/no-image_user.jpg")
                                }
                                className="img-fluid"
                                alt="user"
                              />
                            </span>
                            <span className="block-2">{value.name}</span>
                          </div>
                        </td>
                        <td>{value.id}</td>
                        <td>
                          {value.parent
                            ? CapitalizeFirstLetter(value.relation)
                            : "Parent"}
                        </td>
                        <td className="text-capitalize">
                          <FormGroup className="custom-disable input-remain-content mb-0">
                            <PhoneInput
                              defaultCountry="IN"
                              value={
                                value.phone ? value.phone : "Not Available"
                              }
                              disabled={true}
                              className="h3 input-title lowSize p-0 mb-0"
                            />
                          </FormGroup>
                        </td>
                        <td>{value.email}</td>
                        <td>
                          <div className="action">
                            <div
                              className="edit-action"
                              onClick={() => this.handleClick(value)}
                            >
                              <svg
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g
                                  id="Admin-account"
                                  stroke="none"
                                  stroke-width="1"
                                  fill="none"
                                  fill-rule="evenodd"
                                  opacity="0.5"
                                >
                                  <g
                                    id="Gym"
                                    transform="translate(-1271.000000, -280.000000)"
                                  >
                                    <g
                                      id="edit-24px"
                                      transform="translate(1271.000000, 280.000000)"
                                    >
                                      <polygon
                                        id="Path"
                                        points="0 0 24 0 24 24 0 24"
                                      ></polygon>
                                      <path
                                        d="M3,17.46 L3,20.5 C3,20.78 3.22,21 3.5,21 L6.54,21 C6.67,21 6.8,20.95 6.89,20.85 L17.81,9.94 L14.06,6.19 L3.15,17.1 C3.05,17.2 3,17.32 3,17.46 Z M20.71,7.04 C21.1,6.65 21.1,6.02 20.71,5.63 L18.37,3.29 C17.98,2.9 17.35,2.9 16.96,3.29 L15.13,5.12 L18.88,8.87 L20.71,7.04 Z"
                                        id="Shape"
                                        fill="#000000"
                                        fill-rule="nonzero"
                                      ></path>
                                    </g>
                                  </g>
                                </g>
                              </svg>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <Pagination
                totalCount={this.props.memberCount}
                getData={this.getData}
                {...this.state}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const { members, memberCount } = state.member;
  const { selectAll, selection } = state.select.members;
  return { members, selectAll, selection, memberCount };
};
export default connect(mapStateToProps, {})(MembersList);
